import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

type AreaRegionToggleLabels = {
    area: string;
    region: string;
};

type AreaRegionToggleProps = {
    labels: AreaRegionToggleLabels;
    onChange?: (value: AreaOrRegion) => void;
    isArea: boolean;
};

export enum AreaOrRegion {
    Area = 'area',
    Region = 'region'
}

export function AreaRegionToggle({ labels, onChange, isArea }: AreaRegionToggleProps) {
    let [areaOrRegion, setAreaOrRegion] = React.useState<string>(
        isArea ? AreaOrRegion.Area : AreaOrRegion.Region
    );

    function handleChange(event: any) {
        let value = event.target.value;
        setAreaOrRegion(value);

        if (typeof onChange === 'function') {
            onChange(value);
        }
    }

    return (
        <ToggleButtonGroup
            color="primary"
            sx={{ paddingRight: '16px' }}
            value={areaOrRegion}
            exclusive
            onChange={handleChange}
            aria-label="Area or Region"
        >
            <ToggleButton value={AreaOrRegion.Area}>{labels.area}</ToggleButton>
            <ToggleButton value={AreaOrRegion.Region}>{labels.region}</ToggleButton>
        </ToggleButtonGroup>
    );
}
